"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Chart = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2018 GoodData Corporation
var isEqual_1 = tslib_1.__importDefault(require("lodash/isEqual"));
var noop_1 = tslib_1.__importDefault(require("lodash/noop"));
var react_1 = tslib_1.__importDefault(require("react"));
var chartPlugins_1 = require("./chartPlugins");
var lib_1 = tslib_1.__importDefault(require("../lib"));
var highcharts_more_1 = tslib_1.__importDefault(require("highcharts/highcharts-more"));
var drilldown_1 = tslib_1.__importDefault(require("highcharts/modules/drilldown"));
var treemap_1 = tslib_1.__importDefault(require("highcharts/modules/treemap"));
var bullet_1 = tslib_1.__importDefault(require("highcharts/modules/bullet"));
var funnel_1 = tslib_1.__importDefault(require("highcharts/modules/funnel"));
var heatmap_1 = tslib_1.__importDefault(require("highcharts/modules/heatmap"));
var pattern_fill_1 = tslib_1.__importDefault(require("highcharts/modules/pattern-fill"));
drilldown_1.default(lib_1.default);
treemap_1.default(lib_1.default);
bullet_1.default(lib_1.default);
funnel_1.default(lib_1.default);
heatmap_1.default(lib_1.default);
highcharts_more_1.default(lib_1.default);
pattern_fill_1.default(lib_1.default);
chartPlugins_1.initChartPlugins(lib_1.default);
/**
 * @internal
 */
var Chart = /** @class */ (function (_super) {
    tslib_1.__extends(Chart, _super);
    function Chart() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.setChartRef = function (ref) {
            _this.chartRef = ref;
        };
        return _this;
    }
    Chart.prototype.componentDidMount = function () {
        this.createChart(this.props.config);
    };
    Chart.prototype.shouldComponentUpdate = function (nextProps) {
        if (isEqual_1.default(this.props.config, nextProps.config)) {
            return false;
        }
        return true;
    };
    Chart.prototype.componentDidUpdate = function () {
        this.createChart(this.props.config);
    };
    Chart.prototype.componentWillUnmount = function () {
        this.chart.destroy();
    };
    Chart.prototype.getHighchartRef = function () {
        return this.chartRef;
    };
    Chart.prototype.getChart = function () {
        if (!this.chart) {
            throw new Error("getChart() should not be called before the component is mounted");
        }
        return this.chart;
    };
    Chart.prototype.createChart = function (config) {
        var chartConfig = config.chart;
        this.chart = new lib_1.default.Chart(tslib_1.__assign(tslib_1.__assign({}, config), { chart: tslib_1.__assign(tslib_1.__assign({}, chartConfig), { renderTo: this.chartRef }) }), this.props.callback);
    };
    Chart.prototype.render = function () {
        return react_1.default.createElement("div", tslib_1.__assign({}, this.props.domProps, { ref: this.setChartRef }));
    };
    Chart.defaultProps = {
        callback: noop_1.default,
        domProps: {},
    };
    return Chart;
}(react_1.default.Component));
exports.Chart = Chart;
//# sourceMappingURL=Chart.js.map